import { useNavigate, useSearchParams } from "react-router-dom";

const HandleGoBackOrClose = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleGoBackOrClose = () => {
    if (searchParams.get("newWindow")) {
      window.close();
      return;
    }

    if (window.history.length > 1) {
      navigate(-1);
    } else {
      window.close();
    }
  };

  return handleGoBackOrClose;
};

export default HandleGoBackOrClose;
